// extracted by mini-css-extract-plugin
export default {"title":"Titel_title__cVaCc"};